/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';
import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.OnboardingAppUrlResponse, (requestParams: vp.OnboardingAppUrlRequest) => void, () => void];

function useFetchPartnerOnboardingAppUrlInfo({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.OnboardingAppUrlRequest>();
  const [response, setResponse] = useState<vp.OnboardingAppUrlResponse>({
    ErrorMessage: '',
    Success: false,
    OnboardingURL: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.OnboardingAppUrlRequest) => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const res = await api.fetchOnboardingAppUrl(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.OnboardingAppUrlRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        OnboardingURL: '',
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchPartnerOnboardingAppUrlInfo);
